// Single source of truth for product branding in the web app.
// Product name shows in the sidebar, auth screens, footer and document title.

export const APP_NAME = 'Vayu Saathi';
export const COMPANY_NAME = 'Vayu Solar';
export const COMPANY_TAGLINE = 'Making Solar Spotless';

// Brand palette from vayusolar.com — keep in sync with globals.css
export const BRAND_COLORS = {
  orange: '#F4722E',
  primary: '#EC6726',
  navy: '#1C4C8C',
  navyDeep: '#0D2547',
  sky: '#BCF5FD',
} as const;
